import { optionTitle_conversations } from './ConversationsOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
let ConversationsOption: LazyOption = createLazyOption(
    {
        key: 'conversations',
        titleStringKey: optionTitle_conversations,
        searchTermsStringKey: optionTitle_conversations,
        allowedOptionKeys: ['Conversations'],
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export default ConversationsOption;
